module.exports = __webpack_public_path__ + "img/hospitium-08.e764d3e5.jpg";